import { ApplicationSourceEnum } from "../../dto/applicationSource.enum";

export const ORDERING_APP_SOURCES = [
  ApplicationSourceEnum.WEB_ORDERING,
  ApplicationSourceEnum.WEB_ORDERING_WHITELABEL,
  ApplicationSourceEnum.WEB_ORDER_AT_TABLE,
  ApplicationSourceEnum.ULTRA_ORDER
];
